import type {
  CreateSaUserRequest,
  SaUserDto,
  UpdateSaUserRequest,
} from '@sellokart/shared';
import { api } from '@/lib/api';

export const saUserKeys = {
  all: ['sa-users'] as const,
  list: () => ['sa-users', 'list'] as const,
};

export function fetchSaUsers(signal?: AbortSignal): Promise<SaUserDto[]> {
  return api.get<SaUserDto[]>('/admin/sa-users', { signal });
}

export function createSaUser(input: CreateSaUserRequest): Promise<SaUserDto> {
  return api.post<SaUserDto>('/admin/sa-users', input);
}

export function updateSaUser(
  id: string,
  input: UpdateSaUserRequest,
): Promise<SaUserDto> {
  return api.patch<SaUserDto>(`/admin/sa-users/${id}`, input);
}

export function resetSaUserPassword(
  id: string,
  newPassword: string,
): Promise<SaUserDto> {
  return api.post<SaUserDto>(`/admin/sa-users/${id}/reset-password`, {
    newPassword,
  });
}
